import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import JourneyTimeline from './components/JourneyTimeline';
import ValuesSection from './components/ValuesSection';
import CredentialsSection from './components/CredentialsSection';




const AboutMission = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    
    <div className="min-h-screen bg-background">
      
      <Header />
      {/* Main Content */}
      <main className="pt-16">
        <HeroSection />
        <JourneyTimeline />
        <ValuesSection />
        <CredentialsSection />
      </main>
      {/* Footer */}
      <footer className="bg-deep-space text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex items-center justify-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-rocket-fire to-electric-cyan rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">P</span>
              </div>
              <div>
                <h3 className="text-xl font-headline text-sky-500">PortFolio</h3>
                <p className="text-xs text-slate-400">Ready To Developer</p>
              </div>
            </div>
            
            <p className="text-slate-400 mb-6 max-w-2xl mx-auto">
              Ready to launch into the next phase of my career. Let's build something amazing together.
            </p>
            
            <div className="border-t border-slate-700 pt-6">
              <p className="text-slate-500 text-sm">
                 Crafted with passion and precision by Lokendra Kumar.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutMission;